import { AVERAGE_HOURS_IN_MONTH } from '@cast/constants';
import { WorkloadOptimizationCosts } from '@cast/types';
import { toBig } from '@cast/utils';

import { Savings } from '../../_types';

export const normalizeWorkloadsSavings = ({
  recommended,
  requested,
  originalRequested,
}: WorkloadOptimizationCosts): Savings => {
  const estimatedMonthlySavings = toBig(requested || 0)
    .sub(recommended || 0)
    .mul(AVERAGE_HOURS_IN_MONTH)
    .toNumber();

  const currentMonthlyCost = toBig(requested || 0)
    .mul(AVERAGE_HOURS_IN_MONTH)
    .toNumber();

  const currentRecommendedMonthlyCost = toBig(recommended || 0)
    .mul(AVERAGE_HOURS_IN_MONTH)
    .toNumber();

  const estimatedMonthlySavingsPercentage = currentMonthlyCost
    ? toBig(estimatedMonthlySavings).div(currentMonthlyCost).mul(100).toNumber()
    : 0;

  const currentMonthlySavings = toBig(originalRequested || 0)
    .sub(requested || 0)
    .mul(AVERAGE_HOURS_IN_MONTH)
    .toNumber();

  const originalMonthlyCost = toBig(originalRequested || 0)
    .mul(AVERAGE_HOURS_IN_MONTH)
    .toNumber();

  const currentMonthlySavingsPercentage = originalMonthlyCost
    ? toBig(currentMonthlySavings).div(originalMonthlyCost).mul(100).toNumber()
    : 0;

  return {
    estimatedMonthlySavings,
    estimatedMonthlySavingsPercentage,
    currentMonthlySavings,
    currentMonthlySavingsPercentage,
    currentMonthlyCost,
    currentRecommendedMonthlyCost,
  };
};
